<app-form-modal-shell
  [visible]="visible()"
  heading="Adres inwestycji"
  size="medium"
  dialogWidth="40rem"
  [submitFormId]="formId"
  [saving]="saving()"
  [submitDisabled]="facade.form.invalid"
  [confirmOnDirtyExit]="true"
  [hasPendingChanges]="hasPendingChanges()"
  [confirmDiscardMessage]="'Masz niezapisane zmiany adresu inwestycji. Czy na pewno chcesz je odrzucić?'"
  (visibleChange)="onVisibleChange($event)"
  (hidden)="onHidden()"
  (saveRequested)="onSaveRequested()"
>
  <form
    class="investment-location-modal"
    [id]="formId"
    [formGroup]="facade.form"
    (ngSubmit)="onSaveRequested()"
  >
    <!-- Intentionally no autocomplete for address fields: this flow is a one-off data entry, not a repeatable address form. -->

    <div class="investment-location-modal__grid">
      <app-form-field
        class="investment-location-modal__field"
        label="Kod pocztowy"
        [required]="true"
        [error]="addressFieldError('postalCode')"
        [disabled]="saving()"
      >
        <input
          pInputText
          fluid
          formFieldControl
          formControlName="postalCode"
          type="text"
          inputmode="numeric"
          placeholder="00-000"
          [attr.pattern]="postalCodePattern"
        />
      </app-form-field>

      <app-form-field
        class="investment-location-modal__field"
        label="Województwo"
        [required]="true"
        [error]="addressFieldError('voivodeship')"
        [disabled]="saving()"
      >
        <p-select
          formFieldControl
          formControlName="voivodeship"
          [options]="voivodeshipOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Wybierz województwo"
          [appendTo]="'body'"
          fluid
        />
      </app-form-field>

      <app-form-field
        class="investment-location-modal__field"
        label="Powiat"
        [required]="true"
        [error]="addressFieldError('district')"
        [disabled]="saving()"
      >
        <input
          pInputText
          fluid
          formFieldControl
          formControlName="district"
          type="text"
        />
      </app-form-field>

      <app-form-field
        class="investment-location-modal__field"
        label="Gmina"
        [required]="true"
        [error]="addressFieldError('commune')"
        [disabled]="saving()"
      >
        <input
          pInputText
          fluid
          formFieldControl
          formControlName="commune"
          type="text"
        />
      </app-form-field>

      <app-form-field
        class="investment-location-modal__field"
        label="Miasto"
        [required]="true"
        [error]="addressFieldError('city')"
        [disabled]="saving()"
      >
        <input
          pInputText
          fluid
          formFieldControl
          formControlName="city"
          type="text"
        />
      </app-form-field>

      <app-form-field
        class="investment-location-modal__field"
        label="Ulica"
        [required]="true"
        [error]="addressFieldError('street')"
        [disabled]="saving()"
      >
        <input
          pInputText
          fluid
          formFieldControl
          formControlName="street"
          type="text"
        />
      </app-form-field>
    </div>
  </form>
</app-form-modal-shell>
